import { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const TASK_LABEL = {
  "text-generation": "Texte / chat",
  "image-text-to-text": "Vision + texte",
  "text2text-generation": "Seq2Seq",
  other: "Autre",
};

const FIT_OPTIONS = [["all", "Tous les modèles"], ["can_run", "Optimal sur ma machine"], ["runs", "Fonctionne sur ma machine"]];
const SIZE_OPTIONS = [["all", "Toutes les tailles"], ["small", "Petit (< 4B)"], ["medium", "Moyen (4–15B)"], ["large", "Grand (> 15B)"], ["unknown", "Taille inconnue"]];
const READY_OPTIONS = [["all", "Tous les formats"], ["ollama", "Prêt pour Ollama"]];

export function sizeOf(params) {
  if (!params) return "unknown";
  if (params < 4) return "small";
  if (params <= 15) return "medium";
  return "large";
}

function Filter({ label, value, onChange, options, testid }) {
  return (
    <div className="space-y-1">
      <div className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{label}</div>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className="h-9 w-[210px] text-xs"><SelectValue /></SelectTrigger>
        <SelectContent>
          {options.map(([v, l]) => <SelectItem key={v} value={v} className="text-xs">{l}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function TrendingFilters({ filters, setFilters, models, count }) {
  const taskOptions = useMemo(
    () => [["all", "Toutes les tâches"], ...[...new Set(models.map((m) => m.pipeline_tag || "other"))].map((t) => [t, TASK_LABEL[t] || t])],
    [models]
  );
  const set = (k) => (v) => setFilters({ ...filters, [k]: v });
  return (
    <div className="mb-6 flex flex-wrap items-end gap-3 rounded-xl border border-[#1E2638] bg-[#0F141C] p-4" data-testid="trending-filters">
      <Filter label="Compatibilité" value={filters.fit} onChange={set("fit")} testid="trending-filter-fit" options={FIT_OPTIONS} />
      <Filter label="Tâche" value={filters.task} onChange={set("task")} testid="trending-filter-task" options={taskOptions} />
      <Filter label="Taille" value={filters.size} onChange={set("size")} testid="trending-filter-size" options={SIZE_OPTIONS} />
      <Filter label="Installation" value={filters.ready || "all"} onChange={set("ready")} testid="trending-filter-ollama" options={READY_OPTIONS} />
      <div className="ml-auto font-mono2 text-xs text-muted-foreground" data-testid="trending-count">{count} modèle{count > 1 ? "s" : ""}</div>
    </div>
  );
}
